import { z } from 'zod';
/** Código con que la suite aparece en las rutas de envío (`entity_mail_routes.app_code`). */
export const SUITE_APP_CODE = 'suite';
/** Envíos de la suite misma a la gente de una entidad (GUIA §3.10): como el catálogo que publica cada app. */
export const SUITE_MAIL_FEATURES = [
    { code: 'invitation', name: 'Invitación y enlace de activación', description: 'Al agregar a alguien a la entidad o reenviarle la invitación.', group: 'Cuentas', certifiable: false },
    { code: 'password_reset', name: 'Recuperación de contraseña', description: 'Solo para quien pertenece únicamente a esta entidad; si pertenece a varias, sale con el correo de Datalog.', group: 'Cuentas', certifiable: false },
    { code: 'notifications', name: 'Avisos por correo', description: 'La copia por correo de los avisos de la campana de esta entidad, de cualquier app.', group: 'Avisos', certifiable: false },
];
/** `PUT /v1/entities/:slug/mail-routes`: por dónde sale un envío; `route: null` vuelve al correo principal. */
export const mailRouteInputSchema = z.object({
    appCode: z.string().min(1).max(60),
    feature: z.string().min(1).max(80),
    route: z.union([z.object({ sourceId: z.string().uuid() }), z.object({ off: z.literal(true) })]).nullable(),
});
//# sourceMappingURL=mail.js.map